/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2016, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'react',
	'react-dom',
	'underscore',
	'dashboard-analytics/lib/@waca/core-client/js/core-client/ui/core/View',
	'./navigateDialog/NavigationComponent'
], function(React, ReactDOM,  _, View, NavigationComponent) {

	var NavigationDialog = View.extend({
		init: function(options) {
			NavigationDialog.inherited('init', this, arguments);
			this.options = options;
		},

		render: function() {

			let navigationDialog = <NavigationComponent
				possibleItems = { this.options.state.possibleItems }
				eventHandlers = { this.options.state.eventHandler }
			/>;

			this.reactComponents = ReactDOM.render(navigationDialog, this.$el[0]);
			return this;
		},

		remove: function() {
			if (this.$el[0]) {
				ReactDOM.unmountComponentAtNode(this.$el[0]);
			}
		},

		setFocus: function() {}
	});

	return NavigationDialog;
});
